import React from 'react';
import { Loader2, Car } from 'lucide-react';

/**
 * Composant LoadingSpinner réutilisable amélioré
 * Affiche un spinner avec animation fluide et icônes
 */
export const LoadingSpinner = ({ message = "Chargement...", size = "medium", fullScreen = false }) => {
  const sizeClasses = {
    small: "w-6 h-6",
    medium: "w-12 h-12",
    large: "w-16 h-16"
  };

  const containerClasses = fullScreen
    ? "fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 z-50"
    : "flex flex-col items-center justify-center py-8";

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <Loader2 
            className={`${sizeClasses[size]} text-cyan-400 animate-spin`}
            strokeWidth={3}
          />
          <Car 
            className={`${sizeClasses[size]} text-purple-400 absolute inset-0 animate-pulse`}
            strokeWidth={2}
          />
        </div>
        {message && (
          <p className="text-white font-medium text-center animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export const SkeletonLoader = ({ className = '', rows = 3 }) => {
  return (
    <div className={`space-y-4 ${className}`}>
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="animate-pulse">
          <div className="h-4 bg-white/10 rounded-lg w-full mb-2"></div>
          <div className="h-4 bg-white/10 rounded-lg w-3/4"></div>
        </div>
      ))}
    </div>
  );
};

export const CardSkeleton = ({ count = 1 }) => {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <div key={i} className="animate-pulse">
          <div className="bg-white/10 rounded-2xl p-6 space-y-4">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-white/20 rounded w-3/4"></div>
                <div className="h-3 bg-white/20 rounded w-1/2"></div>
              </div>
            </div>
            <div className="h-32 bg-white/20 rounded-xl"></div>
            <div className="flex gap-2">
              <div className="h-8 bg-white/20 rounded-lg flex-1"></div>
              <div className="h-8 bg-white/20 rounded-lg flex-1"></div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default LoadingSpinner;
